import { capitalize } from 'lodash/fp';
import styled, { css, DefaultTheme } from 'styled-components';
import { DesignToken, getToken } from '@optimus-web/common';
import { PictogramSize } from './Pictogram';

const getSize = ({ size, theme }: { size: PictogramSize; theme: DefaultTheme }) => {
    const sizes: Record<PictogramSize, number> = {
        small: getToken('sizing600')({ theme }),
        medium: getToken('sizing800')({ theme }),
        large: getToken('sizing1000')({ theme }),
    };

    return sizes[size];
};

const generateAccentClasses = () => {
    const variants = ['info', 'danger', 'success', 'warning', 'brand'];
    const properties = ['stroke', 'fill'];

    return css`
        [class*='accent'] {
            ${variants.map(
                (variant) => css`
                    &[class*='${variant}'] {
                        ${properties.map(
                            (property) => css`
                                &[class*='${property}'] {
                                    ${property}: ${getToken(`backgroundAccent${capitalize(variant)}` as DesignToken)};
                                }
                            `
                        )}
                    }
                `
            )}
        }
    `;
};

const generateOutlineClasses = () => {
    const options = {
        stop: 'stop-color',
        stroke: 'stroke',
        fill: 'fill',
    };
    return css`
        [class*='outline'] {
            ${Object.entries(options).map(
                ([key, value]) => css`
                    &[class*='${key}'] {
                        ${value}: ${getToken('borderAccent')};
                    }
                `
            )}
        }
    `;
};

export const PictogramElement = styled.svg<{ size: PictogramSize }>`
    display: block;
    width: ${getSize}px;
    height: ${getSize}px;

    [class*='background'] {
        &[class*='stop'] {
            stop-color: ${getToken('backgroundAccentGradient')};
        }
    }

    ${({ size }) =>
        size === 'small' &&
        css`
            [class*='background'] {
                &[class*='path'] {
                    display: none;
                }
            }
        `}

    [class*='static'] {
        fill: ${getToken('backgroundStaticFlat')};
    }

    ${generateOutlineClasses()}
    ${generateAccentClasses()}
`;
